// src/App.js
import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/Login";
import AdminLayout from "./layouts/AdminLayout";
import BannerLayout from "./layouts/BannerLayout";
import ProductLayout from "./layouts/ProductLayout";
import TagLayout from "./layouts/TagLayout";
import ChallengeLayout from "./layouts/ChallengeLayout";
import ExpertQALayout from "./layouts/ExpertQALayout";
import ContentLayout from "./layouts/ContentLayout";
import CreateContentPage from "./pages/CreateContentPage";
import ContentEditPage from "./pages/ContentEditPage";
import DashBoardLayout from "./layouts/DashboardLayout";
import ShortsLayout from "./layouts/ShortsLayout";
import CreateShortsPage from "./pages/CreateShortsPage";
import ShortsEditPage from "./pages/ShortsEditPage";
import UserLayout from "./layouts/UserLayout";
import UserEditPage from "./pages/UserEditPage";

const App = () => {
  // 로그인 여부 확인 (글로벌)
  const [isAuthenticated, setIsAuthenticated] = useState(true);

  useEffect(() => {
    const isLoggedIn = window.sessionStorage.getItem("login");
    console.log(isLoggedIn === "loggin");
    setIsAuthenticated(isLoggedIn === "loggin");
  }, []);

  return (
    <Router>
      <Routes>
        <Route
          path="/*"
          element={isAuthenticated ? <AdminLayout /> : <Navigate to="/login" />}
        >
          <Route path="dashboard" element={<DashBoardLayout />} />
          <Route path="banners" element={<BannerLayout />} />
          <Route path="products" element={<ProductLayout />} />
          <Route path="tags" element={<TagLayout />} />
          <Route path="challenge" element={<ChallengeLayout />} />
          <Route path="qa" element={<ExpertQALayout />} />
          <Route path="contents" element={<ContentLayout />} />
          <Route path="contents/create" element={<CreateContentPage />} />
          <Route path="contents/edit" element={<ContentEditPage />} />
          <Route path="shorts" element={<ShortsLayout />} />
          <Route path="shorts/create" element={<CreateShortsPage />} />
          <Route path="shorts/edit" element={<ShortsEditPage />} />
          <Route path="users" element={<UserLayout />} />
          <Route path="users/detail" element={<UserEditPage />} />
        </Route>
        <Route path="/login" element={<Login />} />
      </Routes>
    </Router>
  );
};

export default App;
